import { render, staticRenderFns } from "./ratioHistory.vue?vue&type=template&id=201981d1&scoped=true"
import script from "./ratioHistory.vue?vue&type=script&lang=js"
export * from "./ratioHistory.vue?vue&type=script&lang=js"
import style0 from "./ratioHistory.vue?vue&type=style&index=0&id=201981d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201981d1",
  null
  
)

export default component.exports